


import Fullscreen from 'vue-fullscreen'
import Vue from 'vue'

Vue.use(Fullscreen)

export default Fullscreen
